import React, {Component} from "react";
import pcbColor from "../../../assets/img/pcbColor.png";
import goldFinger from "../../../assets/img/goldFingers.png";
import panelby1 from "../../../assets/img/panelby1.png";
import panelby2 from "../../../assets/img/panelby2.png";
import impedenceTeming from '../../../assets/img/impedenceTemImg.png'
import {FormattedMessage} from "react-intl";
import InitialQuotationState from "./InitialQuotationState";
import KINGBOARD from "../../../assets/files/KINGBOARD FR-4 Materials Certifications.zip";

let displayTableStyle = {display: 'block'};
let displayCaptionStyle = {display: 'none', color: 'grey'};

class QuotationFieldsHelp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.match.params.id,
            materialType: '2116*1',
            thickness: '0.127mm',
            layer47628Val: '1.1',
            layer42313Val: '1.3',
            layer47628CoreVal: '1.065',
            layer42313CoreVal: '1.265',
            layer6Val: '0.6',
            layer6CoreVal: '0.565',
            activeStyle: {
                background: '#57AF65',
                color: '#fff',
                border: 'solid 2px #57AF65 !important'
            },
            activeStyle4: {
                background: '#57AF65',
                color: '#fff',
                border: 'solid 2px #57AF65 !important'
            }
        };

        this.changeCoreValue4Layer = this.changeCoreValue4Layer.bind(this);
        this.changeCoreValue6Layer = this.changeCoreValue6Layer.bind(this);
    }

    componentDidMount() {
        // console.log("HELPPPPPPP =====> ", this.state.id);
        document.getElementById(this.state.id).scrollIntoView(true);
        // this.nameInput.focus();
    }

    componentWillUnmount() {
        InitialQuotationState.currentTopic = null

    }

    changeCoreValue4Layer = event => {

        let btnId = event.target.id;
        if (btnId === "4l-0.8") {
            this.setState({
                layer47628Val: '0.3',
                layer42313Val: '0.5',
                layer47628CoreVal: '0.265',
                layer42313CoreVal: '0.465',
                activeStyle4: {
                    background: '#DDDDDD',
                    color: '#57AF65',
                    border: 'solid 2px #57AF65 !important'
                }
            });
            displayTableStyle = {display: 'block'};
        }
        if (btnId === "4l-1.0") {
            this.setState({
                layer47628Val: '0.5',
                layer42313Val: '0.7',
                layer47628CoreVal: '0.465',
                layer42313CoreVal: '0.665',
                ssStyle2313Display: {display: 'block'},
                activeStyle4: {
                    background: '#DDDDDD',
                    color: '#57AF65',
                    border: 'solid 2px #57AF65 !important'
                }
            });
            displayTableStyle = {display: 'block'};
        }
        if (btnId === "4l-1.2") {
            this.setState({
                layer47628Val: '0.7',
                layer42313Val: '0.9',
                layer47628CoreVal: '0.665',
                layer42313CoreVal: '0.865',
                activeStyle4: {
                    background: '#DDDDDD',
                    color: '#57AF65',
                    border: 'solid 2px #57AF65 !important'
                }
            });
            displayTableStyle = {display: 'block'};
        }
        if (btnId === "4l-1.6") {
            this.setState({
                layer47628Val: '1.1',
                layer42313Val: '1.3',
                layer47628CoreVal: '1.065',
                layer42313CoreVal: '1.265',
                activeStyle4: {
                    background: '#57AF65',
                    color: '#DDDDDD',
                    border: 'solid 2px #57AF65 !important'
                }
            });
            displayTableStyle = {display: 'block'};
        }
        if (btnId === "4l-2.0") {
            this.setState({
                layer47628Val: '1.5',
                layer47628CoreVal: '1.465',
                activeStyle4: {
                    background: '#DDDDDD',
                    color: '#57AF65',
                    border: 'solid 2px #57AF65 !important'
                }
            });
            displayTableStyle = {display: 'none'};
            displayCaptionStyle = {display: 'block'};
        }
        /*else {
            displayTableStyle = {display: 'block'};
            displayCaptionStyle = {display:'none'};
        }*/

    };

    removeBtnStyle = event => {
        event.target.classList.remove('tt');
    };

    changeCoreValue6Layer = event => {
        let btnId = event.target.id;
        console.log("event ====> ", event.target.id)
        if (btnId === "6l-1.2") {
            this.setState({
                layer6Val: '0.4',
                layer6CoreVal: '0.365',
                materialType: '2116*1',
                thickness: '0.127mm',
                activeStyle: {
                    background: '#DDDDDD',
                    color: '#57AF65',
                    border: 'solid 2px #57AF65 !important'
                }
            });
        }
        if (btnId === "6l-1.6") {
            this.setState({
                layer6Val: '0.6',
                layer6CoreVal: '0.565',
                materialType: '2116*1',
                thickness: '0.127mm',
                activeStyle: {
                    background: '#57AF65',
                    color: '#fff',
                    border: 'solid 2px #57AF65 !important'
                }
            });
        }
        if (btnId === "6l-2.0") {
            this.setState({
                layer6Val: '0.7',
                layer6CoreVal: '0.665',
                materialType: '7628*1',
                thickness: '0.2mm',
                activeStyle: {
                    background: '#DDDDDD',
                    color: '#57AF65',
                    border: 'solid 2px #57AF65 !important'
                }
            });
        }
    };

    render() {
        return (
            <div className="faq-page-layout">
                <div className="help-pcb-inner-background">
                    <div className="font-size-30">
                        <p>
                            用語説明
                        </p>
                    </div>
                    {/*{ InitialQuotationState.currentTopic==null ? 'bbbbbbbbb' : "aaaaaaaaa"}*/}

                    <div id="layerHelp">
                        <label className="help-label">
                            層数
                        </label>
                        <br/>

                        <b><p>以下の表に示す機能を備えた多層基板を製造することができます。</p></b>

                        <div class="row">
                            <div class="col-md-6">

                                <table className="table table-bordered text-center">
                                    <tbody>
                                    <tr className="impd-table-header">

                                        <td bgcolor="#7CAF39">最小配線（トレース）幅 / 間隔</td>
                                        <td bgcolor="#7CAF39">最小穴径</td>
                                        <td bgcolor="#7CAF39">最小BGA</td>
                                    </tr>
                                    <tr>
                                        <td>3.5mil</td>
                                        <td>0.2mm</td>
                                        <td>0.25mm</td>
                                    </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>

                        <p>制御されたインピーダンス基板</p>
                        <p> 1．プリプレグの誘電率：</p>

                        <div class="row">
                            <div class="col-md-6">
                                <table className="table table-bordered text-center">
                                    <tbody>
                                    <tr className="impd-table-header">
                                        <td bgcolor="#7CAF39"> プリプレグタイプ</td>
                                        <td bgcolor="#7CAF39">誘電率</td>
                                    </tr>
                                    <tr>
                                        <td>7628</td>
                                        <td>4.6</td>
                                    </tr>
                                    <tr>
                                        <td>2313</td>
                                        <td>4.05</td>
                                    </tr>
                                    <tr>
                                        <td>2116</td>
                                        <td>4.25</td>
                                    </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>


                        <p>２．半田：</p>

                        <div class="row">
                            <div class="col-md-6">

                                <table className="table table-bordered text-center">
                                    <tbody>
                                    <tr className="impd-table-header">
                                        <td bgcolor="#7CAF39">レジスト厚</td>
                                        <td bgcolor="#7CAF39"> はんだ厚</td>
                                        <td bgcolor="#7CAF39">はんだ誘電率</td>
                                    </tr>
                                    <tr>
                                        <td>0.8mil</td>
                                        <td>0.5mil</td>
                                        <td>3.8</td>
                                    </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>


                        <p>４層インピーダンス制御基板</p>
                        <p> 板厚：</p>
                        <div className='margin-div-quotation'>
                            <button className='btn box-span-quotation' onClick={this.changeCoreValue4Layer} id="4l-0.8">
                                0.8mm
                            </button>
                            &nbsp;&nbsp;
                            <button className='btn box-span-quotation' onClick={this.changeCoreValue4Layer}
                                    id="4l-1.0">1.0mm
                            </button>
                            &nbsp;&nbsp;
                            <button className='btn box-span-quotation' onClick={this.changeCoreValue4Layer}
                                    id="4l-1.2">1.2mm
                            </button>
                            &nbsp;&nbsp;
                            <button id="4l-1.6" className='btn box-span-quotation' onClick={this.changeCoreValue4Layer}
                                    style={this.state.activeStyle4}>1.6mm
                            </button>
                            &nbsp;&nbsp;
                            <button className='btn box-span-quotation' onClick={this.changeCoreValue4Layer}
                                    id="4l-2.0">2.0mm
                            </button>

                        </div>

                        <p>a) ７６２８スタックアップ：</p>

                        <div class="row">
                            <div class="col-md-8">

                                <table className="table table-bordered text-center">
                                    <tbody>
                                    <tr className="impd-table-header">
                                        <td>層</td>
                                        <td>材料の種類</td>
                                        <td>厚さ</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>外層1</td>
                                        <td className='color-green-quotation'>銅</td>
                                        <td>0.035mm</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>プリプレグ</td>
                                        <td>7628*1</td>
                                        <td>0.2mm</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>内層２</td>


                                        <td className='color-green-quotation'> 銅</td>
                                        <td className='color-orange-quotation'>0.0175mm</td>
                                        <td className='color-orange-quotation border-unset-quotation'></td>
                                    </tr>
                                    <tr>


                                        <td>コア</td>
                                        <td className='color-light-orange-quotation'>コア</td>
                                        <td className='color-orange-quotation'>{this.state.layer47628CoreVal}mm</td>
                                        <td className='color-orange-quotation border-unset-quotation'>{this.state.layer47628Val}mm</td>
                                    </tr>
                                    <tr>
                                        <td>内層３</td>


                                        <td className='color-green-quotation'> 銅</td>
                                        <td className='color-orange-quotation'>0.0175mm</td>
                                        <td className='color-orange-quotation border-unset-quotation'></td>
                                    </tr>
                                    <tr>
                                        <td>プリプレグ</td>
                                        <td>7628*1</td>
                                        <td>0.2mm</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>外層4</td>
                                        <td className='color-green-quotation'>銅</td>
                                        <td>0.035mm</td>
                                        <td></td>
                                    </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>

                        <div style={displayTableStyle}>
                            <p>b) ２３１３スタックアップ</p>

                            <div class="row">
                                <div class="col-md-8">
                                    <table className="table table-bordered text-center" id="tbl-2313-desc">
                                        <tbody>
                                        <tr className="impd-table-header">
                                            <td>層</td>
                                            <td>材料の種類</td>
                                            <td>厚さ</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>外層1</td>
                                            <td className='color-green-quotation'>銅</td>
                                            <td>0.035mm</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>プリプレグ</td>
                                            <td>2313*1</td>
                                            <td>0.1mm</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>内層２</td>


                                            <td className='color-green-quotation'> 銅</td>
                                            <td className='color-orange-quotation'>0.0175mm</td>
                                            <td className='color-orange-quotation border-unset-quotation'></td>
                                        </tr>
                                        <tr>


                                            <td>コア</td>
                                            <td className='color-light-orange-quotation'>コア</td>
                                            <td className='color-orange-quotation'>{this.state.layer42313CoreVal}mm</td>
                                            <td className='color-orange-quotation border-unset-quotation'>{this.state.layer42313Val}mm</td>
                                        </tr>
                                        <tr>
                                            <td>内層３</td>


                                            <td className='color-green-quotation'> 銅</td>
                                            <td className='color-orange-quotation'>0.0175mm</td>
                                            <td className='color-orange-quotation border-unset-quotation'></td>
                                        </tr>
                                        <tr>
                                            <td>プリプレグ</td>
                                            <td>2313*1</td>
                                            <td>0.1mm</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>外層4</td>
                                            <td className='color-green-quotation'>銅</td>
                                            <td>0.035mm</td>
                                            <td></td>
                                        </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>

                        <div style={displayCaptionStyle}>
                            <span>注：2.0厚の4層ボードは、7628スタックアップのみを提供します。</span>
                        </div>
                        <br/><br/>

                        <p>6層インピーダンス制御基板
                        </p> <br/>
                        <p>板厚：</p>


                        <div className='margin-div-quotation'>
                            <button className='btn box-span-quotation' id="6l-1.2"
                                    onClick={this.changeCoreValue6Layer}>1.2mm
                            </button>
                            &nbsp;&nbsp;
                            <button className='btn box-span-quotation' style={this.state.activeStyle} id="6l-1.6"
                                    onClick={this.changeCoreValue6Layer}>1.6mm
                            </button>
                            &nbsp;&nbsp;
                            <button className='btn box-span-quotation' id="6l-2.0"
                                    onClick={this.changeCoreValue6Layer}>2.0mm
                            </button>

                        </div>
                        <p>b) ２３１３スタックアップ：</p>

                        <div class="row">
                            <div class="col-md-8">
                                <table className="table table-bordered text-center">
                                    <tbody>
                                    <tr className="impd-table-header">
                                        <td>層</td>
                                        <td>材料の種類</td>
                                        <td>厚さ</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>内層1</td>
                                        <td className='color-green-quotation'>銅</td>
                                        <td>0.035mm</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>プリプレグ</td>
                                        <td>2313*1</td>
                                        <td>0.1mm</td>
                                        <td></td>
                                    </tr>
                                    <tr>


                                        <td>内層2</td>
                                        <td className='color-green-quotation'> 銅</td>
                                        <td className='color-orange-quotation'>0.0175mm</td>
                                        <td className='border-unset-quotation color-orange-quotation'></td>
                                    </tr>
                                    <tr>


                                        <td>コア</td>
                                        <td className='color-light-orange-quotation'>コア</td>
                                        <td className='color-orange-quotation'>{this.state.layer6CoreVal}mm</td>
                                        <td className='border-unset-quotation color-orange-quotation'>{this.state.layer6Val}mm</td>
                                    </tr>
                                    <tr>


                                        <td>内層３</td>
                                        <td className='color-green-quotation'>銅</td>
                                        <td className='color-orange-quotation'>0.0175mm</td>
                                        <td className='border-unset-quotation color-orange-quotation'></td>
                                    </tr>
                                    <tr>
                                        <td>プリプレグ
                                        </td>
                                        <td>{this.state.materialType}</td>
                                        <td>{this.state.thickness}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>内層4</td>
                                        <td className='color-green-quotation'>銅</td>
                                        <td className='color-orange-quotation'>0.0175mm</td>
                                        <td className='border-unset-quotation color-orange-quotation'></td>
                                    </tr>
                                    <tr>
                                        <td>コア</td>
                                        <td className='color-light-orange-quotation'>コア</td>
                                        <td className='color-orange-quotation'>{this.state.layer6CoreVal}mm</td>
                                        <td className='border-unset-quotation color-orange-quotation'>{this.state.layer6Val}mm</td>
                                    </tr>
                                    <tr>


                                        <td>内層５</td>
                                        <td className='color-green-quotation'>銅</td>
                                        <td className='color-orange-quotation'>0.0175mm</td>
                                        <td className='border-unset-quotation color-orange-quotation'></td>
                                    </tr>

                                    <tr>
                                        <td>プリプレグ
                                        </td>
                                        <td>2313*1</td>
                                        <td>0.1mm</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>外層6</td>
                                        <td className='color-green-quotation'>銅</td>
                                        <td>0.035mm</td>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <p>注：６層基板は一時的に２３１３スタックアップのみを対応します。</p>

                    </div>
                    <br/>

                    {/*</div>*/}


                    <br/>

                    <div id="dimensionsHelp">
                        <label className="help-label">サイズ</label><br/>
                        {/*<p> 当社製造可能サイズ*/}
                        {/*</p>*/}
                        {/*<p> 片面・両面基板については*/}
                        {/*</p>*/}
                        {/*<p> 最小5mm×5mmから400mm×500mmサポートしております。*/}
                        {/*</p>*/}
                        {/*<p> 4層・6層基板については*/}
                        {/*</p>*/}
                        {/*<p> 最小5mm×5mmから390mm×390mmサポートしております。*/}
                        {/*</p>*/}
                        <p>当社製造可能サイズ</p>
                        <p> 片面・両面・4層・6層基板については</p>
                        <p>最小6mm×6mmから400mm×500mmサポートしております。</p>
                        <br/>
                        <p> <b>板厚による製造可能サイズについて</b>
                        </p>
                        <br/>
                        <div class="row">
                            <div class="col-md-8">
                                {/*<table className="table table-bordered">*/}
                                {/*<thead className="thead-dark impd-table-header">*/}
                                {/*<tr>*/}
                                {/*<th bgcolor="#7CAF39" scope="col">板厚</th>*/}
                                {/*<th bgcolor="#7CAF39" scope="col">層数</th>*/}
                                {/*<th bgcolor="#7CAF39" scope="col">製造可能サイズ</th>*/}
                                {/*</tr>*/}
                                {/*</thead>*/}
                                {/*<tbody>*/}
                                {/*<tr>*/}
                                {/*<td>ｔ1.0からt1.6mm</td>*/}
                                {/*<td>片面・両面基板</td>*/}
                                {/*<td>最小5mm×5mm 最大400mm×500mm</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*<td>ｔ1.0からt1.6mm</td>*/}
                                {/*<td>4層・6層基板</td>*/}
                                {/*<td>最小5mm×5mm 最大390mm×390mm</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*<td>ｔ0.4からt0.8mm</td>*/}
                                {/*<td>片面・両面基板</td>*/}
                                {/*<td>最小6mm×10mm 最大300mm×300mm</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*<td>ｔ0.4からt0.6mm</td>*/}
                                {/*<td> 片面・両面基板</td>*/}
                                {/*<td>最小10mm×10mm 最大300mm×300mm</td>*/}
                                {/*</tr>*/}
                                {/*</tbody>*/}
                                {/*</table>*/}


                                <table className="table table-bordered">
                                    <thead className="thead-dark impd-table-header">
                                    <tr>
                                        <th bgcolor="#7CAF39" scope="col">板厚</th>
                                        <th bgcolor="#7CAF39" scope="col">層数</th>
                                        <th bgcolor="#7CAF39" scope="col">製造可能サイズ</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>t0.8 ～ 2.0mm</td>
                                        <td>片面</td>
                                        <td>
                                            <p>最小 <br className="responsive-break-mobile"/>6mm×6mm </p>
                                            <p>最大 <br className="responsive-break-mobile"/>400mm×500mm</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>t0.4 ～ 2.0mm</td>
                                        <td>2層</td>
                                        <td>
                                            <p>最小 <br className="responsive-break-mobile"/>6mm×6mm </p>
                                            <p>最大 <br className="responsive-break-mobile"/>400mm×500mm</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>t0.8 ～ 2.0mm</td>
                                        <td>4層</td>
                                        <td>
                                            <p>最小 <br className="responsive-break-mobile"/>6mm×6mm </p>
                                            <p>最大 <br className="responsive-break-mobile"/>400mm×500mm</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>t1.2 ～ 2.0mm</td>
                                        <td>6層</td>
                                        <td>
                                            <p>最小 <br className="responsive-break-mobile"/>6mm×6mm </p>
                                            <p>最大 <br className="responsive-break-mobile"/>400mm×500mm</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                        <br/>


                        {/*<p>*/}
                        {/*※20mm×20mm以下の場合はフライング検査が対応できません、フライング検査が必要な場合は、20mm×20mm以上確保して下さい。*/}
                        {/*</p>  */}
                        <p>
                            20mm×20mm以下の場合はフライング検査が対応できません、フライング検査が必要な場合は、20mm×20mm以上確保して下さい。
                        </p>
                        <p>
                            ※Vカットによるシート面付の場合、最小サイズ70mm×70mm以上、最大サイズ400mm×400mmです。
                        </p>
                    </div>
                    <br/>

                    <div id="qtyHelp">
                        <label className="help-label">枚数</label><br/>
                        最終基板製造コストを削減のため、独自製造ラインを構築しております、お客様にはご不便をおかけしますが、発注枚数はプルダウンメニューに記載しております枚数でお選びください。
                        {/*1.0mm以上の場合、板厚公差は±10％です。*/}
                    </div>
                    <br/>

                    <div id="thicknessHelp">
                        <label className="help-label">板厚 </label><br/>
                        <p> 下記、板厚をサポートしております。
                        </p>
                        <p> 0.4mm、0.6mm、0.8mm、1.0mm、1.2mm、1.6mm、2.0mm
                        </p>
                        <p> 板厚による公差
                        </p>
                        <p> 1.0mm未満の場合、板厚公差は±0.10mmです。
                        </p>
                        <p> 1.0mm以上の場合、板厚公差は±10％です。
                        </p>
                    </div>
                    <br/>

                    {/*<div id="impedenceHelp">*/}
                    {/*    /!*<label className="help-label">インピーダンス</label><br/>*!/*/}
                    {/*    /!*<p> ※ 国際配送便のため、到着予定日中の到着になります。*!/*/}
                    {/*    /!*</p>*!/*/}
                    {/*    /!*<p> ※ お届け予定は運送会社様の事情、交通事情、気象状況等により予定日にお届けできない場合がございます。*!/*/}
                    {/*    /!*</p>*!/*/}
                    {/*    /!*<p> ※ 到着日が土曜日、日曜日及び祝祭日の商品に関しましては、場合により到着予定日にお届けできない事がございます。*!/*/}
                    {/*    /!*</p>*!/*/}
                    {/*    /!*<img src={impedenceTeming} alt="" className="impedenceTeming"/>*!/*/}

                    {/*    /!*開発中*!/*/}


                    {/*    /!*<p>link 1</p>*!/*/}

                    {/*    <b><p className="help-label">*/}
                    {/*        インピーダンス制御が必要な多層基板*/}
                    {/*    </p></b>*/}


                    {/*    <b><p>以下の表に示す機能を備えた多層基板を製造することができます。</p></b>*/}

                    {/*    <div class="row">*/}
                    {/*        <div class="col-md-6">*/}

                    {/*            <table className="table table-bordered text-center">*/}
                    {/*                <tbody>*/}
                    {/*                <tr className="impd-table-header">*/}

                    {/*                    <td bgcolor="#7CAF39">最小線幅 / 間隔</td>*/}
                    {/*                    <td bgcolor="#7CAF39">最小穴径</td>*/}
                    {/*                    <td bgcolor="#7CAF39">最小BGA</td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>0.35mil</td>*/}
                    {/*                    <td>0.2mm</td>*/}
                    {/*                    <td>0.3mm</td>*/}
                    {/*                </tr>*/}
                    {/*                </tbody>*/}

                    {/*            </table>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}

                    {/*    <p>制御されたインピーダンス基板</p>*/}
                    {/*    <p> 1．プリプレグ比誘電率：</p>*/}

                    {/*    <div class="row">*/}
                    {/*        <div class="col-md-6">*/}
                    {/*            <table className="table table-bordered text-center">*/}
                    {/*                <tbody>*/}
                    {/*                <tr className="impd-table-header">*/}
                    {/*                    <td bgcolor="#7CAF39"> プリプレグタイプ</td>*/}
                    {/*                    <td bgcolor="#7CAF39">誘電率</td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>7628</td>*/}
                    {/*                    <td>4.6</td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>2313</td>*/}
                    {/*                    <td>4.05</td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>2116</td>*/}
                    {/*                    <td>4.25</td>*/}
                    {/*                </tr>*/}
                    {/*                </tbody>*/}

                    {/*            </table>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}


                    {/*    <p>２．半田：</p>*/}

                    {/*    <div class="row">*/}
                    {/*        <div class="col-md-6">*/}

                    {/*            <table className="table table-bordered text-center">*/}
                    {/*                <tbody>*/}
                    {/*                <tr className="impd-table-header">*/}
                    {/*                    <td bgcolor="#7CAF39">レジスト厚</td>*/}
                    {/*                    <td bgcolor="#7CAF39"> はんだ厚</td>*/}
                    {/*                    <td bgcolor="#7CAF39">はんだ誘電率</td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>0.8mil</td>*/}
                    {/*                    <td>0.5mil</td>*/}
                    {/*                    <td>3.8</td>*/}
                    {/*                </tr>*/}
                    {/*                </tbody>*/}

                    {/*            </table>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}


                    {/*    <p>４層インピーダンス制御基板</p>*/}
                    {/*    <p> 板厚：</p>*/}
                    {/*    <div className='margin-div-quotation'>*/}
                    {/*        <button className='btn box-span-quotation' onClick={this.changeCoreValue4Layer} id="4l-0.8">*/}
                    {/*            0.8mm*/}
                    {/*        </button>*/}
                    {/*        &nbsp;&nbsp;*/}
                    {/*        <button className='btn box-span-quotation' onClick={this.changeCoreValue4Layer}*/}
                    {/*                id="4l-1.0">1.0mm*/}
                    {/*        </button>*/}
                    {/*        &nbsp;&nbsp;*/}
                    {/*        <button className='btn box-span-quotation' onClick={this.changeCoreValue4Layer}*/}
                    {/*                id="4l-1.2">1.2mm*/}
                    {/*        </button>*/}
                    {/*        &nbsp;&nbsp;*/}
                    {/*        <button id="4l-1.6" className='btn box-span-quotation' onClick={this.changeCoreValue4Layer}*/}
                    {/*                style={this.state.activeStyle4}>1.6mm*/}
                    {/*        </button>*/}
                    {/*        &nbsp;&nbsp;*/}
                    {/*        <button className='btn box-span-quotation' onClick={this.changeCoreValue4Layer}*/}
                    {/*                id="4l-2.0">2.0mm*/}
                    {/*        </button>*/}

                    {/*    </div>*/}

                    {/*    <p>a) ７６２８スタックアップ：</p>*/}

                    {/*    <div class="row">*/}
                    {/*        <div class="col-md-8">*/}

                    {/*            <table className="table table-bordered text-center">*/}
                    {/*                <tbody>*/}
                    {/*                <tr className="impd-table-header">*/}
                    {/*                    <td>層</td>*/}
                    {/*                    <td>材料の種類</td>*/}
                    {/*                    <td>厚さ</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>外層1</td>*/}
                    {/*                    <td className='color-green-quotation'>銅</td>*/}
                    {/*                    <td>0.035mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>プリプレグ</td>*/}
                    {/*                    <td>7628*1</td>*/}
                    {/*                    <td>0.2mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>内層２</td>*/}


                    {/*                    <td className='color-green-quotation'> 銅</td>*/}
                    {/*                    <td className='color-orange-quotation'>0.0175mm</td>*/}
                    {/*                    <td className='color-orange-quotation border-unset-quotation'></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}


                    {/*                    <td>コア</td>*/}
                    {/*                    <td className='color-light-orange-quotation'>コア</td>*/}
                    {/*                    <td className='color-orange-quotation'>{this.state.layer47628CoreVal}mm</td>*/}
                    {/*                    <td className='color-orange-quotation border-unset-quotation'>{this.state.layer47628Val}mm</td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>内層３</td>*/}


                    {/*                    <td className='color-green-quotation'> 銅</td>*/}
                    {/*                    <td className='color-orange-quotation'>0.0175mm</td>*/}
                    {/*                    <td className='color-orange-quotation border-unset-quotation'></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>プリプレグ</td>*/}
                    {/*                    <td>7628*1</td>*/}
                    {/*                    <td>0.2mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>外層4</td>*/}
                    {/*                    <td className='color-green-quotation'>銅</td>*/}
                    {/*                    <td>0.035mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                </tbody>*/}

                    {/*            </table>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}

                    {/*    <div style={displayTableStyle}>*/}
                    {/*        <p>b) ２３１３スタックアップ</p>*/}

                    {/*        <div class="row">*/}
                    {/*            <div class="col-md-8">*/}
                    {/*                <table className="table table-bordered text-center" id="tbl-2313-desc">*/}
                    {/*                    <tbody>*/}
                    {/*                    <tr className="impd-table-header">*/}
                    {/*                        <td>層</td>*/}
                    {/*                        <td>材料の種類</td>*/}
                    {/*                        <td>厚さ</td>*/}
                    {/*                        <td></td>*/}
                    {/*                    </tr>*/}
                    {/*                    <tr>*/}
                    {/*                        <td>外層1</td>*/}
                    {/*                        <td className='color-green-quotation'>銅</td>*/}
                    {/*                        <td>0.035mm</td>*/}
                    {/*                        <td></td>*/}
                    {/*                    </tr>*/}
                    {/*                    <tr>*/}
                    {/*                        <td>プリプレグ</td>*/}
                    {/*                        <td>2313*1</td>*/}
                    {/*                        <td>0.1mm</td>*/}
                    {/*                        <td></td>*/}
                    {/*                    </tr>*/}
                    {/*                    <tr>*/}
                    {/*                        <td>内層２</td>*/}


                    {/*                        <td className='color-green-quotation'> 銅</td>*/}
                    {/*                        <td className='color-orange-quotation'>0.0175mm</td>*/}
                    {/*                        <td className='color-orange-quotation border-unset-quotation'></td>*/}
                    {/*                    </tr>*/}
                    {/*                    <tr>*/}


                    {/*                        <td>コア</td>*/}
                    {/*                        <td className='color-light-orange-quotation'>コア</td>*/}
                    {/*                        <td className='color-orange-quotation'>{this.state.layer42313CoreVal}mm</td>*/}
                    {/*                        <td className='color-orange-quotation border-unset-quotation'>{this.state.layer42313Val}mm</td>*/}
                    {/*                    </tr>*/}
                    {/*                    <tr>*/}
                    {/*                        <td>内層３</td>*/}


                    {/*                        <td className='color-green-quotation'> 銅</td>*/}
                    {/*                        <td className='color-orange-quotation'>0.0175mm</td>*/}
                    {/*                        <td className='color-orange-quotation border-unset-quotation'></td>*/}
                    {/*                    </tr>*/}
                    {/*                    <tr>*/}
                    {/*                        <td>プリプレグ</td>*/}
                    {/*                        <td>2313*1</td>*/}
                    {/*                        <td>0.1mm</td>*/}
                    {/*                        <td></td>*/}
                    {/*                    </tr>*/}
                    {/*                    <tr>*/}
                    {/*                        <td>外層4</td>*/}
                    {/*                        <td className='color-green-quotation'>銅</td>*/}
                    {/*                        <td>0.035mm</td>*/}
                    {/*                        <td></td>*/}
                    {/*                    </tr>*/}
                    {/*                    </tbody>*/}

                    {/*                </table>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}

                    {/*    <div style={displayCaptionStyle}>*/}
                    {/*        <span>注：2.0厚の4層ボードは、7628スタックアップのみを提供します。</span>*/}
                    {/*    </div>*/}
                    {/*    <br/><br/>*/}

                    {/*    <p>6層インピーダンス制御基板*/}
                    {/*    </p> <br/>*/}
                    {/*    <p>板厚：</p>*/}


                    {/*    <div className='margin-div-quotation'>*/}
                    {/*        <button className='btn box-span-quotation' id="6l-1.2"*/}
                    {/*                onClick={this.changeCoreValue6Layer}>1.2mm*/}
                    {/*        </button>*/}
                    {/*        &nbsp;&nbsp;*/}
                    {/*        <button className='btn box-span-quotation' style={this.state.activeStyle} id="6l-1.6"*/}
                    {/*                onClick={this.changeCoreValue6Layer}>1.6mm*/}
                    {/*        </button>*/}
                    {/*        &nbsp;&nbsp;*/}
                    {/*        <button className='btn box-span-quotation' id="6l-2.0"*/}
                    {/*                onClick={this.changeCoreValue6Layer}>2.0mm*/}
                    {/*        </button>*/}

                    {/*    </div>*/}
                    {/*    <p>b) ２３１３スタックアップ：</p>*/}

                    {/*    <div class="row">*/}
                    {/*        <div class="col-md-8">*/}
                    {/*            <table className="table table-bordered text-center">*/}
                    {/*                <tbody>*/}
                    {/*                <tr className="impd-table-header">*/}
                    {/*                    <td>層</td>*/}
                    {/*                    <td>材料の種類</td>*/}
                    {/*                    <td>厚さ</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>内層1</td>*/}
                    {/*                    <td className='color-green-quotation'>銅</td>*/}
                    {/*                    <td>0.035mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>プリプレグ</td>*/}
                    {/*                    <td>2313*1</td>*/}
                    {/*                    <td>0.1mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}


                    {/*                    <td>内層２</td>*/}
                    {/*                    <td className='color-green-quotation'> 銅</td>*/}
                    {/*                    <td className='color-orange-quotation'>0.0175mm</td>*/}
                    {/*                    <td className='border-unset-quotation color-orange-quotation'></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}


                    {/*                    <td>コア</td>*/}
                    {/*                    <td className='color-light-orange-quotation'>コア</td>*/}
                    {/*                    <td className='color-orange-quotation'>{this.state.layer6CoreVal}mm</td>*/}
                    {/*                    <td className='border-unset-quotation color-orange-quotation'>{this.state.layer6Val}mm</td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}


                    {/*                    <td>内層３</td>*/}
                    {/*                    <td className='color-green-quotation'>銅</td>*/}
                    {/*                    <td className='color-orange-quotation'>0.0175mm</td>*/}
                    {/*                    <td className='border-unset-quotation color-orange-quotation'></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>プリプレグ*/}
                    {/*                    </td>*/}
                    {/*                    <td>2116*1</td>*/}
                    {/*                    <td>0.127mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>内層4</td>*/}
                    {/*                    <td className='color-green-quotation'>銅</td>*/}
                    {/*                    <td className='color-orange-quotation'>0.0175mm</td>*/}
                    {/*                    <td className='border-unset-quotation color-orange-quotation'></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>コア</td>*/}
                    {/*                    <td className='color-light-orange-quotation'>コア</td>*/}
                    {/*                    <td className='color-orange-quotation'>{this.state.layer6CoreVal}mm</td>*/}
                    {/*                    <td className='border-unset-quotation color-orange-quotation'>{this.state.layer6Val}mm</td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}


                    {/*                    <td>内層５</td>*/}
                    {/*                    <td className='color-green-quotation'>銅</td>*/}
                    {/*                    <td className='color-orange-quotation'>0.0175mm</td>*/}
                    {/*                    <td className='border-unset-quotation color-orange-quotation'></td>*/}
                    {/*                </tr>*/}

                    {/*                <tr>*/}
                    {/*                    <td>プリプレグ*/}
                    {/*                    </td>*/}
                    {/*                    <td>2313*1</td>*/}
                    {/*                    <td>0.1mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                <tr>*/}
                    {/*                    <td>外層6</td>*/}
                    {/*                    <td className='color-green-quotation'>銅</td>*/}
                    {/*                    <td>0.035mm</td>*/}
                    {/*                    <td></td>*/}
                    {/*                </tr>*/}
                    {/*                </tbody>*/}
                    {/*            </table>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}

                    {/*    <p>注：６層基板は一時的に２３１３スタックアップのみを対応します。</p>*/}

                    {/*</div>*/}
                    <br/>

                    <div id="colorHelp">
                        <label className="help-label">レジスト色</label><br/>
                        <p> レジストインク（ソルダーマスク）の色指定です。なお白いソルダーマスクの場合はシルク印字が黒色、他のカラーの場合、シルク印字は白色となります。
                        </p>
                        <p> ご注意：注文確認後、色を変更することはできません。
                        </p>
                        <div className="row">
                            <img src={pcbColor} className="img-pcbClr" width="45%" height="45%"/>
                        </div>
                    </div>
                    <br/>

                    <div id="surfaceFinishHelp">
                        <label className="help-label">表面処理</label><br/>
                        HASL（有鉛はんだレベラー）HASL-RoHs（鉛フリーはんだレベラー）ENIG-RoHs（無電解金メッキ）
                    </div>
                    <br/>

                    <div id="copperWeightHelp">
                        <label className="help-label">銅厚</label><br/>
                        <p> 外層部のみの銅箔の厚さの選択です、内層の銅厚については17.5µm（0.5oz)です。
                        </p>
                    </div>
                    <br/>

                    <div id="goldFingerHelp">
                        <label className="help-label">端子仕上げ</label><br/>
                        <p> 表面処理オプションでENIGを選択された場合は金メッキで仕上がります。
                        </p>
                        <p> HASLを選択された場合はHASL（有鉛はんだレベラー）で仕上がります。
                        </p>
                        <div>
                            <img src={goldFinger} className="img-div"/>
                        </div>
                    </div>
                    <br/>

                    <div id="materialDetHelp">
                        <label className="help-label">材料</label><br/>
                        <p> FR-4標準Tg140Cを使用しています。それ以外の材質は対応しておりません。
                        </p>
                        <p>
                            {/*詳しくはFR-4 Material.pdfをご確認下さい。*/}
                            KINGBOARD FR-4の材料認証：<a href={KINGBOARD}>こちらからダウンロードしてください。</a>
                        </p>
                    </div>
                    <br/>

                    <div id="panelByJlcpcbHelp">
                        <label className="help-label">KITCUTでの面付け希望</label><br/>
                        <p>
                            KITCUTによるシート面付けをご希望の場合
                        </p>
                        <div className="row center">
                            <img src={panelby1} className="img-help-1"/>
                        </div>
                        <p>
                            下記のシート面付けをご希望の場合、X=5、Y=2と入力して下さい。
                        </p>
                        <div className="row">
                            <img src={panelby2} className="img-help-1"/>
                        </div>
                        <br/>
                        <ol>
                            <li>
                                次のような場合はVカットによるシート面付けは対応できません。
                                シートサイズの長さが70mmより小さい場合
                            </li>
                            <li>円、長方形、正方形または三角形のような規則的な基板によるシート面付けです
                                複雑な基板外形の場合は、お客様側にてシート形状データにてご注文お願いします。
                            </li>
                            <li>板厚による最大シートサイズ
                                <ul>
                                    <li> t0.6mmの場合 最大100mm×100mm
                                    </li>
                                    <li> t0.8から1.2mmの場合 最大200mm×200mm
                                    </li>
                                    {/*<li> t1.6mmの場合 最大300mm×300mm*/}
                                    {/*</li>*/}
                                    <li> t1.6mmの場合 最大390mm×390mm
                                    </li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                    <br/>

                    <div id="edgeRailsHelp">
                        <label className="help-label">捨て基板 </label><br/>
                        <p>
                            捨て基板を付けることにより、実装効率が上がったり、不良を減らすことができます。
                        </p>
                        <p> Rをつけることにより他の基板へのキズや欠け防止の対策となります。
                        </p>
                    </div>
                    <br/>

                    <div id="panelHelp">
                        <label className="help-label">面付けサイズ
                        </label><br/>
                        <p>
                            数種類の基板の「面付け」の場合、各基板の単価が下がり、また、捨て基板を設けた面付けをする事で、実装の単価も下がる可能性があります。
                        </p>

                    </div>
                    <br/>

                    <div id="probeTestHelp">
                        <label className="help-label">フライング検査 </label><br/>
                        {/*<p>*/}
                        {/*1層・2層基板についてのフライング検査はオプション選択となります。*/}
                        {/*</p>*/}
                        {/*<p> ４層・6層基板については50枚までフライング検査が標準で実施されます。*/}
                        {/*</p>*/}
                        {/*<p>*/}
                        {/*50枚上の場合は、フライング検査費用が発生します。*/}
                        {/**/}
                        {/*</p>*/}
                        {/* <p>
                            50枚までフライング検査が標準で実施されます。
                        </p>
                        <p>
                            50枚以上の場合フライング検査費用が発生します。

                        </p>*/}
                        <p>検査体制</p>
                        <p>片面：50枚以下は全数検査 50枚を超える場合は枚数に対して15％を抜き取りにより検査</p>
                        <p>両面：30枚以下は全数検査 30枚を超える場合は枚数に対して15％を抜き取りにより検査</p>
                        <p>4層：全数検査</p>
                        <p>6層：全数検査</p>

                    </div>
                    <br/>

                    <div id="castellatedtHelp">
                        <label className="help-label">キャスタレーション</label><br/>
                        基板側面に半円のスルーホール形状を加工しメタライズすることで基板の表裏の導通が取れます。穴のサイズは最小で0.6 mm必要です、穴の間のスペースも最小で0.6 mm必要です。
                    </div>
                    <br/>

                    <div id="differentDesignHelp">
                        <label className="help-label">異種面付け</label><br/>
                        基板の種類がいくつあるかを選択してください、複数ある場合は異種面付けとなります。
                    </div>
                </div>
            </div>
        );
    }
}

export default QuotationFieldsHelp;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/QuotationFieldsHelp.js